import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="rounded-xl border border-rose-200 bg-rose-50 p-6 text-sm text-rose-900">
          <p className="font-semibold">No se pudo cargar esta página</p>
          <p className="mt-2 text-rose-800">{this.state.error?.message || String(this.state.error)}</p>
          <button
            type="button"
            className="mt-4 rounded-lg bg-rose-600 px-3 py-1.5 text-white hover:bg-rose-700"
            onClick={() => window.location.reload()}
          >
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
